/** Zod validation schemas for storage folder CRUD and bulk actions */

import { z } from 'zod'

export const createStorageFolderSchema = z.object({
  name: z.string().min(1).max(200),
  parentId: z.string().nullable().optional(),
})

export const updateStorageFolderSchema = z.object({
  name: z.string().min(1).max(200).optional(),
  parentId: z.string().nullable().optional(),
  position: z.number().int().min(0).optional(),
})

export const bulkMoveSchema = z.object({
  fileIds: z.array(z.string()).default([]),
  folderIds: z.array(z.string()).default([]),
  targetFolderId: z.string().nullable(),
})

export const bulkDeleteSchema = z.object({
  fileIds: z.array(z.string()).default([]),
  folderIds: z.array(z.string()).default([]),
})

export const moveFileSchema = z.object({
  folderId: z.string().nullable(),
})

/** Storage collections. A `meme` upload is never extracted, summarized, embedded, searched, or sent to an agent's context */
export const UPLOAD_COLLECTIONS = ['meme'] as const
export type UploadCollection = (typeof UPLOAD_COLLECTIONS)[number]
export const MEME_COLLECTION: UploadCollection = 'meme'
/** Extraction status of an upload kept out of extraction and agent context (a meme) */
export const EXCLUDED_EXTRACTION_STATUS = 'excluded'

/** Memes are images (GIF included) or videos */
export function isMemeContentType(contentType: string): boolean {
  const type = contentType.toLowerCase()
  return type.startsWith('image/') || type.startsWith('video/')
}

/** PATCH /api/uploads/:id/collection; null returns the upload to ordinary knowledge */
export const setUploadCollectionSchema = z.object({
  collection: z.enum(UPLOAD_COLLECTIONS).nullable(),
})

/** GET /api/uploads?collection= : one collection, `none` (no collection), or `all` (default) */
export const uploadCollectionFilterSchema = z.enum(['meme', 'none', 'all'])
export type UploadCollectionFilter = z.infer<typeof uploadCollectionFilterSchema>
